import { API_BASE_URL } from '../config/api';
import {
  backendEntriesAsApiMaterials,
  backendMaterialPath,
} from '../config/backendMaterialCatalog';

export { backendMaterialPath };

const SHAPE_META = {
  Bone: {
    key: 'bone',
    previewId: 'bone',
    name: 'Bone',
    description: 'Classic bone shape with rounded edges - a timeless favorite',
  },
  Square: {
    key: 'rectangle',
    previewId: 'rect',
    name: 'Rectangle',
    description: 'Clean rectangular design - maximum engraving space',
  },
  Circle: {
    key: 'circle',
    previewId: 'circ',
    name: 'Circle',
    description: 'Timeless circular tag - simple and elegant',
  },
  Hex: {
    key: 'hexagon',
    previewId: 'hex',
    name: 'Hexagon',
    description: 'Distinctive hexagonal design - modern and stylish',
  },
  Hexagon: {
    key: 'hexagon',
    previewId: 'hex',
    name: 'Hexagon',
    description: 'Distinctive hexagonal design - modern and stylish',
  },
  Triangle: {
    key: 'triangle',
    previewId: 'tri',
    name: 'Triangle',
    description: 'Unique triangular shape - stands out from the crowd',
  },
};

export function materialImageUrl(imageurl) {
  if (!imageurl) return null;
  if (imageurl.startsWith('http://') || imageurl.startsWith('https://')) {
    return imageurl;
  }
  return `${API_BASE_URL}${imageurl}`;
}

export function colorNameFromImageUrl(imageurl) {
  if (!imageurl) return 'Unknown';
  const base = imageurl.split('/').pop().replace(/\.[^.]+$/, '');
  const parts = base.split('-');
  if (parts.length < 3) return 'Unknown';
  const colorSlug = parts.slice(1, -1).join('-');
  return colorSlug
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export function isMaterialInStock(mat) {
  return (mat.instockcount ?? 0) > 0 && !mat.in_back_order;
}

export function buildCatalogFromMaterials(materials = []) {
  const shapes = {};

  materials.forEach((mat) => {
    if (!isMaterialInStock(mat)) return;

    const shapeMeta = SHAPE_META[mat.shape];
    if (!shapeMeta) return;

    const image = materialImageUrl(mat.imageurl);
    if (!image) return;

    if (!shapes[shapeMeta.key]) {
      shapes[shapeMeta.key] = {
        name: shapeMeta.name,
        description: shapeMeta.description,
        defaultImage: image,
        colors: [],
      };
    }

    const colorName = colorNameFromImageUrl(mat.imageurl);
    shapes[shapeMeta.key].colors.push({
      id: `mat-${mat.id}`,
      name: colorName,
      color: colorName.toLowerCase().replace(/\s+/g, ''),
      image,
      materialId: mat.id,
      inventoryId: mat.inventory_id,
      instockcount: mat.instockcount,
      colorHex: mat.colorhex,
    });
  });

  return shapes;
}

/** Offline / API-failure fallback using backendlaser /materials/ photos */
export function buildFallbackCatalog() {
  return buildCatalogFromMaterials(backendEntriesAsApiMaterials());
}

export function resolveMaterialImage(src) {
  if (!src) return null;
  if (src.startsWith('http://') || src.startsWith('https://')) return src;
  if (src.startsWith('/')) return materialImageUrl(src);
  return src;
}

export function buildStockMap(materials = []) {
  const map = {};
  materials.forEach((mat) => {
    map[mat.id] = {
      inStock: isMaterialInStock(mat),
      count: mat.instockcount ?? 0,
      inBackOrder: mat.in_back_order ?? false,
      materialId: mat.id,
      inventoryId: mat.inventory_id,
    };
  });
  return map;
}
